/*
  Variant-swap fetch guard for product recommendations + recently-viewed.

  Changing a variant on a grouped/gang product swaps the entire <main>
  (see product-info.js -> handleSwapProduct -> HTMLUpdateUtility.viewTransition).
  That re-creates the <product-recommendations> sections ("Recommended For You"
  and "Complementary products") and the <recently-viewed-products> section (which
  fetches routes.search_url), so each one runs its init/visibility logic again
  and re-fetches its URL.

  To avoid re-requesting content we already have for this page session, cache
  the rendered markup per URL and restore it when a re-created element comes
  back into view. New URLs (e.g. switching to a different gang product, or a
  changed recently-viewed query) still fetch as normal.
*/
(function () {
  if (!('customElements' in window)) return;

  const cache = new Map();

  function fetchAndRender(element, url, targetSelector) {
    if (url && cache.has(url)) {
      element.innerHTML = cache.get(url);
      return;
    }

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
        if (html === null) return;

        const target = html.querySelector(targetSelector);
        if (target && target.innerHTML.trim().length) {
          const content = target.innerHTML;
          element.innerHTML = content;
          cache.set(url, content);
        }
      })
      .catch((e) => console.error(e));
  }

  customElements.whenDefined('product-recommendations').then((Recommendations) => {
    if (Recommendations.__recommendationsFetchGuarded) return;
    Recommendations.__recommendationsFetchGuarded = true;

    Recommendations.prototype.handleIntersection = function (entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetchAndRender(this, this.dataset.url, 'product-recommendations');
    };
  });

  customElements.whenDefined('recently-viewed-products').then((RecentlyViewed) => {
    if (RecentlyViewed.__recentlyViewedFetchGuarded) return;
    RecentlyViewed.__recentlyViewedFetchGuarded = true;

    RecentlyViewed.prototype.init = function () {
      fetchAndRender(this, this.dataset.url + this.getQueryString(), 'recently-viewed-products');
    };
  });
})();
